import React, { useState } from "react";

import UserAllPage from "./UserAll";
import UserSubmittedPage from "./UserSubmitted";
import UserUpdatesPage from "./UserUpdates";
import UserAcceptedPage from "./UserAccepted";
import UserRejectedPage from "./UserRejected";

function Status({ userDetails, setParentLoading, activeStatusTab}){
return (
        <div >
             
                {/* CONTENTS */}

                <div
                    style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    padding: "10px",
                    boxSizing: "border-box"
                }}
                >

                    {/* ALL */}

                    {activeStatusTab === "userall" &&
                        <div className="fade-container">
                          <UserAllPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* SUBMITTED */}

                    {activeStatusTab === "usersubmitted" &&
                        <div className="fade-container">
                          <UserSubmittedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* UPDATES */}

                    {activeStatusTab === "userupdates" &&
                        <div className="fade-container">
                          <UserUpdatesPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }
                    
                    {/* ACCEPTED */}

                     {activeStatusTab === "useraccepted" &&
                        <div className="fade-container">
                          <UserAcceptedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                    {/* REJECTED */}

                     {activeStatusTab === "userrejected" &&
                        <div className="fade-container">
                          <UserRejectedPage setParentLoading={setParentLoading} userDetails={userDetails} />
                        </div>
                    }

                </div>

        </div>
    )
}

export default Status;